/**
 * Recently Viewed Products Section
 * Stores viewed products in localStorage and displays them
 */
(function() {
  const STORAGE_KEY = 'motomachina_recently_viewed';
  const MAX_STORED = 20;

  // Get recently viewed products from localStorage
  function getRecentlyViewed() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  // Save product to recently viewed
  function saveProduct(product) {
    if (!product || !product.id) return;

    let viewed = getRecentlyViewed();

    // Remove if already exists (to move to front)
    viewed = viewed.filter(p => p.id !== product.id);

    // Add to beginning
    viewed.unshift(product);

    // Limit storage
    if (viewed.length > MAX_STORED) {
      viewed = viewed.slice(0, MAX_STORED);
    }

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
    } catch (e) {
      console.warn('Could not save recently viewed products');
    }
  }

  // Track current product on product pages
  function trackCurrentProduct() {
    const productJson = document.querySelector('[data-product-json]');
    if (!productJson) return;

    try {
      const product = JSON.parse(productJson.textContent);
      const variant = product.variants && product.variants[0];

      const productData = {
        id: product.id,
        title: product.title,
        handle: product.handle,
        url: '/products/' + product.handle,
        vendor: product.vendor || '',
        price: product.price || (variant && variant.price) || 0,
        compare_at_price: product.compare_at_price || (variant && variant.compare_at_price) || 0,
        image: product.featured_image || (product.images && product.images[0]) || '',
        timestamp: Date.now()
      };

      saveProduct(productData);
    } catch (e) {
      console.warn('Could not track product');
    }
  }

  // Format money (Indian Rupees)
  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Build product card HTML
  function buildProductCard(product) {
    const hasDiscount = product.compare_at_price && product.compare_at_price > product.price;
    const discountPercent = hasDiscount
      ? Math.round((product.compare_at_price - product.price) / product.compare_at_price * 100)
      : 0;

    return `
      <a href="${product.url}" class="recently-viewed__card">
        <div class="recently-viewed__card-media">
          ${product.image
            ? `<img src="${product.image}" alt="${product.title}" class="recently-viewed__card-image" loading="lazy">`
            : '<div class="recently-viewed__card-placeholder"><i class="fa-solid fa-image"></i></div>'
          }
          ${hasDiscount ? `<span class="recently-viewed__card-badge">-${discountPercent}%</span>` : ''}
        </div>
        <div class="recently-viewed__card-content">
          ${product.vendor ? `<span class="recently-viewed__card-vendor">${product.vendor}</span>` : ''}
          <h3 class="recently-viewed__card-title">${product.title}</h3>
          <div class="recently-viewed__card-price">
            <span class="recently-viewed__card-price-current${hasDiscount ? ' recently-viewed__card-price-current--sale' : ''}">${formatMoney(product.price)}</span>
            ${hasDiscount ? `<span class="recently-viewed__card-price-compare">${formatMoney(product.compare_at_price)}</span>` : ''}
          </div>
        </div>
      </a>
    `;
  }

  // Initialize section
  function initRecentlyViewed() {
    const section = document.querySelector('[data-recently-viewed]');
    if (!section) return;

    const grid = section.querySelector('[data-rv-grid]');
    const emptyState = section.querySelector('[data-rv-empty]');
    const prevBtn = section.querySelector('[data-rv-prev]');
    const nextBtn = section.querySelector('[data-rv-next]');
    const maxProducts = parseInt(section.dataset.maxProducts) || 8;
    const currentProductId = section.dataset.currentProduct;

    let viewed = getRecentlyViewed();

    // Filter out current product if on product page
    if (currentProductId) {
      viewed = viewed.filter(p => p.id.toString() !== currentProductId.toString());
    }

    // Limit to max products
    viewed = viewed.slice(0, maxProducts);

    // Show empty state if no products
    if (viewed.length === 0) {
      section.setAttribute('data-empty', 'true');
      if (emptyState) emptyState.style.display = 'flex';
      if (grid) grid.style.display = 'none';
      return;
    }

    // Build end card HTML (styled like a product card)
    const endCardHtml = `
      <a href="/collections/all" class="recently-viewed__card recently-viewed__card--end">
        <div class="recently-viewed__card-media">
          <div class="recently-viewed__card-placeholder recently-viewed__card-placeholder--end">
            <i class="fa-solid fa-gears"></i>
          </div>
        </div>
        <div class="recently-viewed__card-content">
          <span class="recently-viewed__card-vendor">Browse More</span>
          <h3 class="recently-viewed__card-title">That's all for now!</h3>
          <div class="recently-viewed__card-price">
            <span class="recently-viewed__card-price-current">Explore Products <i class="fa-solid fa-arrow-right"></i></span>
          </div>
        </div>
      </a>
    `;

    // Build and insert product cards
    if (grid) {
      grid.innerHTML = viewed.map(buildProductCard).join('') + endCardHtml;
    }

    // Initialize Owl Carousel if available
    if (typeof jQuery !== 'undefined' && jQuery.fn.owlCarousel && grid) {
      const $grid = jQuery(grid);

      $grid.owlCarousel({
        items: 4,
        loop: viewed.length > 4,
        margin: 20,
        nav: false,
        dots: false,
        responsive: {
          0: { items: 2, margin: 12 },
          576: { items: 3, margin: 16 },
          992: { items: 4, margin: 20 },
          1200: { items: 5, margin: 20 }
        }
      });

      // Navigation buttons
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          $grid.trigger('prev.owl.carousel');
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          $grid.trigger('next.owl.carousel');
        });
      }
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      trackCurrentProduct();
      initRecentlyViewed();
    });
  } else {
    trackCurrentProduct();
    initRecentlyViewed();
  }
})();
